import Grid from "@material-ui/core/Grid";
import React from "react";

import useStyles from "../../MUIClasses/useStyles";
import MainCard from "../../components/Cards/MainCard";
import Wrapper from "../../components/Common/Wrapper";

import { finalBanners, signUpForParticipantsLimit, signUpLimit } from "../../Constants";
import MainGoldenCard from "../../components/Cards/MainGoldenCard";

import { convertTimestampToReadableDate, isSubscriptionAvailable, isSubscriptionForParticipantsAvailableAgain } from "../../utils";

const Main = () => {

  return (
    <Wrapper footer={true} loaded={true}>
      <Grid container justify="center">
        <Grid
          spacing={4}
          alignItems="center"
          justify="center"
          container
          className={useStyles().grid}
        >
          <MainGoldenCard
            title="Bem-vind@ à III Mostra Científica e Tecnológica da UFSC Curitibanos"
            description="Quer saber mais? Clique neste card!"
            target="/mais"
            linkBtn
            icon="info icon"
          />
          <MainCard
            title="Informações e Inscrição no Evento"
            description="Clique no botão abaixo e confira as informações"
            target="/mais?tab=como-fazer-minha-inscricao-no-evento"
            linkBtn
            icon="help"
          />
          <MainCard
            title="Programação"
            description="Datas importantes do evento"
            target="/programacao"
            linkBtn
            icon="list sharp alt"
          />
          {
            isSubscriptionAvailable() ? (
              <>
                <MainCard
                  title="PRORROGADO! Inscrição de Resumos"
                  description={`Inscreva seu resumo no evento. De ${convertTimestampToReadableDate(signUpLimit.min, true)} até ${convertTimestampToReadableDate(signUpLimit.max, true)}`}
                  target="/inscreva-se"
                  linkBtn
                  icon="assignment"
                />
                <MainCard
                  title="Modelo de Resumo"
                  description={`Confira o modelo de resumo`}
                  target="/mais?tab=modelo-de-resumo"
                  linkBtn
                  icon="cloud_download"
                />
                </>
            )
              :
              isSubscriptionForParticipantsAvailableAgain() ?
                <MainCard
                  title="Inscrições como participantes reabertas!"
                  description={`Inscreva-se no evento para ter acesso ao ConTech. De ${convertTimestampToReadableDate(signUpForParticipantsLimit.min, true)} até ${convertTimestampToReadableDate(signUpForParticipantsLimit.max, true)}`}
                  target="/inscreva-se"
                  linkBtn
                  icon="assignment"
                />
                :
                finalBanners ?
                  <MainCard
                    title="Inscrições Encerradas"
                    description="-"
                  />
                  :
                  <MainGoldenCard
                    title={"Inscrições serão abertas em breve!\nDe " + convertTimestampToReadableDate(signUpLimit.min, true) + " até " + convertTimestampToReadableDate(signUpLimit.max, true)}
                    description="Aguarde para mais informações no ConTech"
                  />

          }

          <MainGoldenCard
            title="Nossos Apoiadores"
            description="Confira nossos Apoiadores"
            target="/mais?tab=apoiadores"
            linkBtn
            icon="favorite"
            iconColor={useStyles().pink}
          />

          <MainCard
            title="Página da UFSC da 'III Mostra Científica e Tecnológica'"
            description="Confira a página da Mostra Científica e Tecnológica da UFSC Curitibanos"
            target="https://1mostracientificacbs.paginas.ufsc.br"
            icon="public"
            externalLink
          />

          <MainGoldenCard
            title="I Mostra Científica e Tecnológica da UFSC Curitibanos - 2020"
            description="Confira a I Mostra Científica e Tecnológica da UFSC Curitibanos do ano de 2020"
            target="https://contech-cbs.web.app/"
            icon="receipt_long"
            externalLink
          />


        </Grid>
      </Grid>

    </Wrapper>
  );
}

export default Main;